import React from "react";
import ApexCharts from "react-apexcharts";

const ChartComponent = ({ progressSums, progressOptions, type, DirectSum, DirectUser }) => {
  // Initialize progress sums for each option, setting default values to 0
  const progressData = progressOptions?.reduce((sums, option) => {
    sums[option.value] = progressSums[option.value] || 0;
    return sums;
  }, {});
  // Prepare chart options and data
  const chartOptions = {
    chart: {
      id: "progress-chart",
      type: type,
      height: 300
    },
    xaxis: {
      categories: progressOptions?.map(option => option.label) || [DirectUser],
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    labels: progressOptions?.map(option => option.label) || [DirectUser],
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        if (type === 'pie') return opts.w.globals.series[opts.seriesIndex];
        else return val;
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      enabled: true,
    },
    plotOptions: {
      pie: {
        expandOnClick: true
      }
    }
  };

  // Prepare chart series based on the selected chart type
  const chartSeries = type === "pie"
    ? progressOptions?.map(option => progressData[option.value]) || [DirectSum]
    : [
      {
        name: "Total",
        data: progressOptions?.map(option => progressData[option.value]) || [DirectSum]
      }
    ];

  if (type === "pie" && chartSeries.every(value => value === 0)) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        fontSize: '16px',
        color: '#111',
        fontStyle: 'italic',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
      }}>
        No data available for the pie chart.
      </div>
    );
  }

  return (
    <div id="chart">
      <ApexCharts options={chartOptions} series={chartSeries} type={type} height={350} />
    </div>
  );
};

export default ChartComponent;
